module.exports = __webpack_public_path__ + "img/takeAway.fd232272.svg";